import { DS_BRIEF_CREATE_URL, __, __product } from '@99designs/i18n';
import addressLabelsImage from '../../images/more-products/address-labels.png';
import brochuresImage from '../../images/more-products/brochures.png';
import letterheadsImage from '../../images/more-products/letterheads.png';
import postcardsImage from '../../images/more-products/postcards.png';
import retractableBannersImage from '../../images/more-products/retractable-banners.png';
import weddingInvitationsImage from '../../images/more-products/wedding-invitations.png';
import type { MoreProductsProduct } from '../../types';

const eventDetailsDestinationPagePath = (mpvId: string): string => {
    return `${DS_BRIEF_CREATE_URL}/care-design?mpvId=${mpvId}`;
};

export const products = (): MoreProductsProduct[] => {
    return [
        {
            image: brochuresImage,
            title: __('Folded leaflet design'),
            mpv: __product('mpv-id-brochure'),
            trackingData: {
                category: 'Navigation Clicked',
                label: 'Content:Design Option Tiles',
                eventDetail: `/design;${eventDetailsDestinationPagePath(
                    __product('mpv-id-brochure')
                )};Design Option Tiles;BrochureDesign-CTA`,
                navigationDetail: 'BrochureDesign-CTA:1',
            },
        },
        {
            image: letterheadsImage,
            title: __('Letterhead Design'),
            mpv: __product('mpv-id-letterhead'),
            trackingData: {
                category: 'Navigation Clicked',
                label: 'Content:Design Option Tiles',
                eventDetail: `/design;${eventDetailsDestinationPagePath(
                    __product('mpv-id-letterhead')
                )};Design Option Tiles;LetterheadDesign-CTA`,
                navigationDetail: 'LetterheadDesign-CTA:2',
            },
        },
        {
            image: postcardsImage,
            title: __('Postcard Design'),
            mpv: __product('mpv-id-postcard'),
            trackingData: {
                category: 'Navigation Clicked',
                label: 'Content:Design Option Tiles',
                eventDetail: `/design;${eventDetailsDestinationPagePath(
                    __product('mpv-id-postcard')
                )};Design Option Tiles;PostcardDesign-CTA`,
                navigationDetail: 'PostcardDesign-CTA:3',
            },
        },
        {
            image: retractableBannersImage,
            title: __('Retractable Banner Design'),
            mpv: __product('mpv-id-retractable-banner'),
            trackingData: {
                category: 'Navigation Clicked',
                label: 'Content:Design Option Tiles',
                eventDetail: `/design;${eventDetailsDestinationPagePath(
                    __product('mpv-id-retractable-banner')
                )};Design Option Tiles;RetractableBannerDesign-CTA`,
                navigationDetail: 'RetractableBannerDesign-CTA:4',
            },
        },
        {
            image: addressLabelsImage,
            title: __('Return Address Label Design'),
            mpv: __product('mpv-id-return-address-labels'),
            trackingData: {
                category: 'Navigation Clicked',
                label: 'Content:Design Option Tiles',
                eventDetail: `/design;${eventDetailsDestinationPagePath(
                    __product('mpv-id-return-address-labels')
                )};Design Option Tiles;ReturnAddressLabelDesign-CTA`,
                navigationDetail: 'ReturnAddressLabelDesign-CTA:5',
            },
        },
        {
            image: weddingInvitationsImage,
            title: __('Wedding Invitation Design'),
            mpv: __product('mpv-id-wedding-invitations'),
            trackingData: {
                category: 'Navigation Clicked',
                label: 'Content:Design Option Tiles',
                eventDetail: `/design;${eventDetailsDestinationPagePath(
                    __product('mpv-id-wedding-invitations')
                )};Design Option Tiles;WeddingInvitationDesign-CTA`,
                navigationDetail: 'WeddingInvitationDesign-CTA:6',
            },
        },
    ];
};
